import { useFormikContext } from "formik";
import "./AssignProgress.css";

export const AssignProgress = ({ isLocked = false }) => {
  const { values, setFieldValue } = useFormikContext();
  const kids = values.kids || [];
  const selectedKidIndex = values.progressAssignedTo;

  const handleToggle = (index) => {
    if (isLocked) return;
    // If already selected, deselect (skip); otherwise select
    if (selectedKidIndex === index) {
      setFieldValue("progressAssignedTo", null);
    } else {
      setFieldValue("progressAssignedTo", index);
    }
  };

  const handleSkip = () => {
    if (isLocked) return;
    setFieldValue("progressAssignedTo", null);
  };

  if (kids.length === 0) return null;

  return (
    <div className="assignProgress">
      <div className="assignProgress__header">
        <h3 className="assignProgress__title">Assign the progress to</h3>
      </div>
      <div className="assignProgress__body">
        <p className="assignProgress__description">
          {isLocked
            ? "Progress has already been assigned and cannot be changed."
            : "Select the kid you want to assign the progress to, or skip this step."}
        </p>
        <div className="assignProgress__list">
          {kids.map((kid, index) => (
            <div
              key={index}
              className={`assignProgress__item ${
                selectedKidIndex === index
                  ? "assignProgress__item--selected"
                  : ""
              } ${isLocked ? "assignProgress__item--locked" : ""}`}
              onClick={() => handleToggle(index)}
            >
              <span className="assignProgress__itemName">
                {kid.firstName || `Kid ${index + 1}`}
              </span>
              <div
                className={`assignProgress__checkbox ${
                  selectedKidIndex === index
                    ? "assignProgress__checkbox--checked"
                    : ""
                }`}
              ></div>
            </div>
          ))}
          <div
            className={`assignProgress__item ${
              selectedKidIndex == null ? "assignProgress__item--selected" : ""
            } ${isLocked ? "assignProgress__item--locked" : ""}`}
            onClick={handleSkip}
          >
            <span className="assignProgress__itemName">Skip</span>
            <div
              className={`assignProgress__checkbox ${
                selectedKidIndex == null
                  ? "assignProgress__checkbox--checked"
                  : ""
              }`}
            ></div>
          </div>
        </div>
        {selectedKidIndex == null && !isLocked && (
          <p className="assignProgress__warning">
            If you skip the progress transfer, the current progress will be lost
            and cannot be recovered.
          </p>
        )}
      </div>
    </div>
  );
};
